/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_appsync_graphqlEndpoint": "https://nmrv3qwbw5a3rlzr4pccyuq7zi.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-yfj2iysphncyrirnn45uyfyhfa",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_iQ2xHW1iv",
    "aws_user_pools_web_client_id": "3vlejmpkm7ksvioug4r20bv6nj",
    "oauth": {
        "domain": "ap-northeast-1iq2xhw1iv.auth.ap-northeast-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Admin-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Contact-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Customer-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Product-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Provide-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Seller-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        },
        {
            "tableName": "Selling-6tmev5bluvberlff7ql57zqxu4-pittaput",
            "region": "ap-northeast-1"
        }
    ],
    "Auth": {
        "region": "ap-northeast-1",
        "userPoolId": "ap-northeast-1_iQ2xHW1iv",
        "userPoolWebClientId": "3vlejmpkm7ksvioug4r20bv6nj",
        "identityPoolId": "ap-northeast-1:c1dc5601-3c2a-4b22-a8b4-e9304ea8970a",
        "mandatorySignIn": true,
        "authenticationFlowType": "USER_PASSWORD_AUTH"
    },
    "Storage": {
        "AWSS3": {
            "bucket": "amplify-pittaputreact1-newdev-5a5ac-deployment",
            "region": "ap-northeast-1"
        }
    }
};


export default awsmobile;
